import { render } from "./YieldDataCard.vue?vue&type=template&id=574c07a6"
import script from "./YieldDataCard.vue?vue&type=script&lang=js"
export * from "./YieldDataCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__